import { queryOptions } from "@tanstack/react-query";
import { ApiError, api, unwrap } from "@/client/lib/api";

/**
 * The redirect that brings a browser here writes nothing, so a scanner that only fetches the link
 * changes nothing. Never cached, so coming back after "Turn back on" turns it off again;
 * turning off what is already off writes nothing.
 */
export const unsubscribeQuery = (token: string) =>
  queryOptions({
    queryKey: ["unsubscribe", token],
    staleTime: 0,
    gcTime: 0,
    queryFn: async (): Promise<boolean> => {
      try {
        await unwrap(api.unsubscribe[":token"].$post({ param: { token } }));
        return true;
      } catch (failure) {
        if (failure instanceof ApiError && failure.code === "NOT_FOUND") {
          return false;
        }
        throw failure;
      }
    },
  });
